module.exports = liabilityAccount;